<div class="container">
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row">
        <div class="col-24">
            <h1>{{pageTitle}}</h1>

        </div>
    </div>
    <div class="row">
        <div class="col-24" *ngIf="!isFormValid">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
                </ul>
            </div>
        </div>
        <div class="col-24" *ngIf="successOrErrorMessage">
            <div class="alert success">
                {{successOrErrorMessage}}
            </div>
        </div>
        <div class="col-24" *ngIf="ifWarnings">
            <div class="alert warning">
                <p><em>Warning:</em></p>
                <ul>
                    <li *ngFor="let warning of Warnings"><button>{{warning}}</button></li>
                </ul>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-24">

            <p class="required">All fields are required, unless marked as optional.</p>
        </div>
    </div>


    <UserPersonalDetails [personalDetails]="this.personalDetails" [currentUser]="this.currentUser"
        [profileId]="this.userProfileID" [controlMode]="this.isReadOnly" [statusReason]="this.userStatusReason"
        [BgChkResultDate]="this.bgChkResultDate" (validateEContract)="validateEContract($event)"
        (userTypeSelection)="userTypeSelection($event)"
        (userTypeSelectionEContract)="userTypeSelectionEContract($event)"
        (setEmpIDValidation)="setEmpIDValidation($event)" [isAgentMode]="this.isAdminUpdate"
        [selectedRoleID]="this.selectedRoleID" [userType]="this.userType" [disableLogIn]="this.isLogInDisabled"
        [displayEmpID]="this.displayEmpID" [isAddMode]="this.isAddMode"
        [isBackGroundDisabled]="this.isBackGroundDisabled" [isStatusDisabled]="isStatusDisabled"
        [noMiddleName]="this.noMiddleName" [BgChkStatus]="this.bgChkStatus">
    </UserPersonalDetails>

    <BusinessAndResidentialAddress id="business-residential-address" [businessAddress]="businessAddress"
        [residentialAddress]="residentialAddress" [businessPhone]="businessPhone" [cellPhone]="cellPhone"
        (onResidentialAddressChange)="this.residentialAddress = $event"
        (onBusinessAddressChange)="this.businessAddress = $event" [silverMailOptIn]="silverMailOptIn"
        [isAdminUpdate]="this.isAdminUpdate" (onsilverMailOptInChange)="this.silverMailOptIn = $event">
    </BusinessAndResidentialAddress>

    <div id="divProfile">
        <UserProfileComponent [viewUserProfile]="this.viewUserProfile" (onAddProfile)="this.onAddProfile($event)"
            [screenMode]="this.mode" [isAdminUpdate]="isAdminUpdate" [attestedDetails]="this.AttestedDetails"
            [isRequired]="this.isRequired" [showEcontract]="this.showEContract"
            [econtractDisable]="this.econtractDisable">
        </UserProfileComponent>
    </div>

    <div class="row">
        <div class="col-24">
            <button class="button primary" id="submitAll" [disabled]="isAuditor" (click)="submitForm()">Save</button>

            <button class="button cancel" id="cancel" (click)="Cancel()">Cancel</button>
        </div>
    </div>

    <div class="row">
        @if (!isAddMode) {
        <div class="col-24" id="divEdit">
            <div class="tabs">
                <button type="button" *ngIf="showCommentsTab" (click)="showTabbed(1)"
                    [ngClass]="{'on': commentsScreenShow}" aria-controls="panel-comments" id="comments"
                    role="tab">Comments</button>
                <button *ngIf="showLicenseTab" (click)="showTabbed(2)" [ngClass]="{'on': licenseScreenShow}"
                    aria-controls="panel-license" id="license" role="tab">License</button>
                <button *ngIf="showTrainingTab" (click)="showTabbed(3)" [ngClass]="{'on': trainingScreenShow}"
                    aria-controls="panel-training" id="training" role="tab">Training</button>
            </div>
            <div *ngIf="commentsScreenShow" aria-labelledby="comments" aria-live="assertive" id="panel-comments"
                role="tabpanel">
                <UserComments [commentsViewModel]="this.commentsViewModel"
                    (onCommentAdded)="this.onCommentAdded($event)"></UserComments>
            </div>

            <div *ngIf="licenseScreenShow" aria-labelledby="license" aria-live="assertive" id="panel-license"
                role="tabpanel">
                <License [licenseViewModel]="this.licenseViewModel"></License>

            </div>
            <div *ngIf="trainingScreenShow" aria-labelledby="training" aria-live="assertive" id="panel-training"
                role="tabpanel">
                <UserTraining></UserTraining>
            </div>
        </div>
        }
    </div>
</div>